import { useState, useEffect } from 'react';

export function useCountdown(startedAt: number | null, duration: number): number {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (!startedAt) {
      setTimeLeft(duration);
      return;
    }

    const update = () => {
      const elapsed = Date.now() - startedAt;
      setTimeLeft(Math.max(0, duration - elapsed));
    };

    update();
    const interval = setInterval(update, 100);
    return () => clearInterval(interval);
  }, [startedAt, duration]);

  return timeLeft;
}
